import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import $ from "jquery";
import Flatpickr from "flatpickr";

class PublishModal extends Modal {
    constructor(workingRevision) {
        super({destroyOnClose: true, class: "admin-modal--navigation"});

        let name = !workingRevision.name ? "" : workingRevision.name;

        let $content = (
            eotwJSXFactory('form', {class: "admin-form"}, [
                eotwJSXFactory('p', null, ["Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ut vehicula sapien, sed ullamcorper eros."]),
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('label', {class: "admin-form__label", for: "page-meta-title"}, ["When should this be published?"]),
                    eotwJSXFactory('div', null, [
                        eotwJSXFactory('label', {class: "admin-form__label admin-form__label--smargin"}, [
                            eotwJSXFactory('input', {type: "radio", class: "admin-form__radio-checkbox js-status", name: "status", value: "1", checked: workingRevision.status.id !== "3"}),
                            "Now"
                        ]),
                        eotwJSXFactory('label', {class: "admin-form__label admin-form__label--smargin"}, [
                            eotwJSXFactory('input', {type: "radio", class: "admin-form__radio-checkbox js-status", name: "status", value: "3", checked: workingRevision.status.id === "3"}),
                            "Schedule"
                        ])
                    ])
                ]),


                eotwJSXFactory('div', {class: "admin-form__col admin-form__col--flex js-schedule-options", style: workingRevision.status.id !== "3" ? "display:none;" : ""}, [
                    eotwJSXFactory('div', {class: "admin-form__row admin-form__row--half"}, [
                        eotwJSXFactory('label', {class: "admin-form__label", for: "page-meta-title"}, ["Revision Name"]),
                        eotwJSXFactory('input', {type: "text", class: "admin-form__input", name: "name", value: name, 'data-optional': workingRevision.status.id !== "3"})
                    ]),
                    eotwJSXFactory('div', {class: "admin-form__row admin-form__row--half"}, [
                        eotwJSXFactory('label', {class: "admin-form__label", for: "page-meta-title"}, ["Live Date"]),
                        eotwJSXFactory('div', {class: "admin-form__input admin-form__input--date"}, [
                            eotwJSXFactory('input', {type: "text", class: "js-date", name: "publishDate", value: "", 'data-optional': workingRevision.status.id !== "3"})
                        ])
                    ])
                ]),


                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Ok"]),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
                ])
            ])
        );

        this.$content.html([
            eotwJSXFactory('div', {class: "admin-modal__navigation"}, [
                eotwJSXFactory('button', {class: "admin-modal__link admin-modal__link--active"}, ["Save & Publish"])
            ]),
            eotwJSXFactory('div', {class: "admin-modal__content"}, [
                $content
            ])
        ]);

        FormValidator.attach($content).on("submit", () => {
            let $btn = $content.find("button[type='submit']");
            if ($btn.is(".admin-btn--loading")) return;
            $btn.addClass("admin-btn--loading");

            let data = $content.serializeJSON();

            $.extend(workingRevision, data);

            this.emit("save", () => {
                $btn.removeClass("admin-btn--loading");
            });
        });

        $content.on("change", ".js-status", () => {
            if ($(".js-status:checked").val() === "3") {
                $content.find(".js-schedule-options").show().find("input").prop("data-optional", false);
            } else {
                $content.find(".js-schedule-options").hide().find("input").prop("data-optional", true);
            }
        });

        new Flatpickr($content.find(".js-date")[0], {
            static: true,
            minDate: new Date,
            enableTime: true,
            altInput: true,
            dateFormat: 'Y-m-d H:i:S',
            animate: false
        });

        this.on("click", ".js-cancel", () => {
            this.emit("cancel");
            this.hide();
            return false;
        });
    }

}

export default PublishModal;
